import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Lightbox from 'react-awesome-lightbox';
import 'react-awesome-lightbox/build/style.css';
import i18n from '../../i18n';
import { CustomTitle } from '../helpers/customTitle';
import { ActiveAuctions } from './auctionsCategory/active';
import { PreviousAuctions } from './auctionsCategory/previous';
import { FeaturedAuctions } from './auctionsCategory/featured';
import { UpcomingAuctions } from './auctionsCategory/upcoming';
import { DirectAuctions } from './auctionsCategory/direct';
import { AllAuctions } from './auctionsCategory/all';
//import { HotMarketAuctions } from "./helpers/hotMarketAuction";
import { getAuctionChartData } from '../../models/auctions';
export class CategoryAuctions extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedTab: 'active',
      active_count: 0,
      upcoming_count: 0,
      firstload: true,
      secondLoad: false,
      tabs: [
        {
          name: i18n.t('active_auctions'),
          tab: 'active',
          icon: process.env.PUBLIC_URL + '/assets/icons/active_auction.png',
          count_color: 'rgba(92,92,92,1)',
        },
        {
          name: i18n.t('upcoming_auctions'),
          tab: 'upcoming',
          icon: process.env.PUBLIC_URL + '/assets/icons/upcoming_auction.png',
          count_color: '#0068C9',
        },
        // {
        //   name: i18n.t("featured_auctions"),
        //   tab: "featured",
        //   icon: process.env.PUBLIC_URL + "/assets/icons/featured_auction.png",
        //   count_color: "#FF4664",
        // },
        {
          name: i18n.t('previous_auctions'),
          tab: 'previous',
          icon: process.env.PUBLIC_URL + '/assets/icons/expired_auction.png',
          count_color: '#46BCFF',
        },
        {
          name: i18n.t('all_auctions'),
          tab: 'all',
          icon: process.env.PUBLIC_URL + '/assets/icons/all_auctions.png',
          count_color: '#8247FF',
        },
        {
          name: i18n.t('direct_sale'),
          tab: 'direct',
          icon: process.env.PUBLIC_URL + '/assets/icons/direct_auctions.png',
          count_color: '#FA00B4',
        },
      ],
      lightboxImages: [],
      is_active_light_box: false,
      counts: {},
      is_loading_1: false,
    };
    this.handleTabs = this.handleTabs.bind(this);
    this.getActiveCount = this.getActiveCount.bind(this);
    this.getUpcomingCount = this.getUpcomingCount.bind(this);
    this.getImagePopup = this.getImagePopup.bind(this);
    this.loadAuctionsCount = this.loadAuctionsCount.bind(this);
  }

  componentDidMount() {
    this.loadAuctionsCount();
  }

  handleTabs(tabname) {
    console.log(tabname);
    this.setState({ selectedTab: tabname });
  }

  getActiveCount(count) {
    if (count === 0 && this.state.firstload) {
      this.setState({
        selectedTab: 'upcoming',
        firstload: false,
        secondLoad: true,
      });
    }
  }

  getUpcomingCount(count) {
    console.log(count);
    if (count === 0 && this.state.secondLoad) {
      this.setState({ selectedTab: 'previous', secondLoad: false });
    }
  }

  getImagePopup(active, images) {
    let lightboxImages = [];
    if (images) {
      images.forEach(function (arrayItem) {
        lightboxImages.push({
          url: arrayItem.image,
        });
      });
    }
    this.setState({
      is_active_light_box: active,
      lightboxImages: lightboxImages,
    });
  }

  async loadAuctionsCount() {
    this.setState({ is_loading_1: true });
    let counts = {};
    const response = await getAuctionChartData('main');
    let data = response.data;
    if (response) {
      counts = {
        active: data.active,
        upcoming: data.upcoming,
        previous: data.previous,
        featured: data.featured,
        direct: data.direct,
        all: Number(data.previous) + Number(data.active),
      };
      this.setState({
        is_loading_1: false,
        counts,
      });
    }
  }

  render() {
    let selectedTab = this.state.selectedTab;
    let tabs = this.state.tabs;
    let currTabObj = tabs.find((obj) => {
      return obj.tab === selectedTab;
    });
    let tabName = currTabObj.name;
    let tabImage = currTabObj.icon;
    return (
      <React.Fragment>
        <section className="mt-2 mb-2 overflow-hidden">
          <div className="container-fluid p-0">
            <div className="section-title center-block text-center">
              <CustomTitle
                title={i18n.t('auctions')}
                icon="ri_auction-fill.png"
                icon_type="img"
                need_mzad_icon={true}
              />
            </div>

            <div className="row mx-5">
              <div className="col-12">

                <div className="auction-tabs-wrapper mb-4">
                  <ul className="nav nav-pills justify-content-center flex-wrap gap-2">
                    {tabs.map((item, i) => (
                      <li key={i} className="nav-item">
                        <button
                          className={
                            "nav-link d-flex align-items-center px-3 py-2 rounded-pill shadow-sm " +
                            (selectedTab === item.tab ? "active-tab" : "inactive-tab")
                          }
                          onClick={() => this.handleTabs(item.tab)}
                        >
                          <i
                            className={
                              "me-2 fs-5 " +
                              (item.tab === "active" ? "ri-auction-fill" :
                                item.tab === "upcoming" ? "ri-time-fill" :
                                  item.tab === "previous" ? "ri-history-line" :
                                    item.tab === "all" ? "ri-list-check" :
                                      item.tab === "direct" ? "ri-shopping-cart-fill" : "")
                            }
                          ></i>
                          <span className="fw-semibold">{item.name}</span>
                          <span
                            className="badge ms-2"
                            style={{
                              backgroundColor: 'rgba(92,92,92,1)',
                              fontSize: "0.75rem",
                            }}
                          >
                            {this.state.is_loading_1 ? "0" : this.state.counts[item.tab]}
                          </span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>



                <div className="mobile-blue-nav-container d-block d-md-none mb-3">
                  <Dropdown className="w-100">
                    <Dropdown.Toggle
                      id="dropdown-autoclose-true"
                      className="w-100 rounded-pill shadow-sm"
                      variant="primary"
                      style={{ backgroundColor: "#189397", border: "none" }}
                    >
                      &nbsp;{tabName}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100">
                      {tabs.map((item, i) => (
                        <Dropdown.Item
                          key={i}
                          onClick={() => this.handleTabs(item.tab)}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div className="d-flex align-items-center">

                            <span className="px-2">{item.name}</span>
                          </div>
                          <span
                            className="badge rounded-pill"
                            style={{
                              backgroundColor: "rgba(92,92,92,1)",
                              fontSize: "0.75rem",
                            }}
                          >
                            {this.state.is_loading_1 ? "0" : this.state.counts[item.tab]}
                          </span>
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            {/* <div className="col-md-12">
              <HotMarketAuctions />
            </div> */}

            <div className="col-md-12">
              <div className="items-gallery">
                <div className="items-blog-tab text-center">
                  <div className="tab-content auc-card-wrapper">
                    {this.state.selectedTab === 'all' && (
                      <div className="tab-pane active">
                        <AllAuctions
                          type={this.state.selectedTab}
                          getActiveCount={this.getActiveCount}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}

                    {this.state.selectedTab === 'active' && (
                      <div className="tab-pane active">
                        <ActiveAuctions
                          type={this.state.selectedTab}
                          getActiveCount={this.getActiveCount}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}

                    {this.state.selectedTab === 'upcoming' && (
                      <div className="tab-pane active">
                        <UpcomingAuctions
                          type={this.state.selectedTab}
                          getUpcomingCount={this.getUpcomingCount}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}

                    {this.state.selectedTab === 'featured' && (
                      <div className="tab-pane active">
                        <FeaturedAuctions
                          type={this.state.selectedTab}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}

                    {this.state.selectedTab === 'previous' && (
                      <div className="tab-pane active">
                        <PreviousAuctions
                          type={this.state.selectedTab}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}

                    {this.state.selectedTab === 'direct' && (
                      <div className="tab-pane active">
                        <DirectAuctions
                          type={this.state.selectedTab}
                          getImagePopup={this.getImagePopup}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {this.state.is_active_light_box && (
          <Lightbox
            images={this.state.lightboxImages}
            onClose={() => {
              this.setState({ is_active_light_box: false });
            }}
          />
        )}
      </React.Fragment>
    );
  }
}
